//fichier CSS principal
import style from "./styles/style.scss";

//fichiers pour le bulles
import bubblecss from "bubbles/dist/main.css";
import bubbleCalcul from "bubbles/dist/main.js";
import bubbleAnim from "bubbles/dist/anims.js";

//Swiper plugin
// import Swiper from "swiper/dist/js/swiper.min.js";
// import SwiperCSS from "swiper/dist/css/swiper.css";

//tag XITI
import xiti from "../../../_global/scripts/data-xiti.js";

//plugin de lazyloading
// import lazy from "lazysizes";
// window.lazySizesConfig = window.lazySizesConfig || {};
// window.lazySizesConfig.srcAttr = 'data-lazy';
// window.lazySizesConfig.expand = 350;

// import para from "./scripts/parallax.min.js"


$j(document).ready(function() {
	// $j('.para__root').parallax({imageSrc: "/images/para.jpg"});
});